<template>
    <Form :rules="innerRules" :value="list" inline populateType="chain">
        <field-group
            v-for="(item, index) in list"
            :key="index"
            :model="item"
            class="parameter-item"
        >
            <FormItem prop="title" class="parameter-item-title">
                <Input v-model="item.title" style="width: 100%;" placeholder="请输入品牌名称、型号等" />
            </FormItem>
            <FormItem prop="price" class="parameter-item-price">
                <input-number v-model="item.price" style="width: 100%;" placeholder="请输入价格">
                    <span slot="append">元</span>
                </input-number>
            </FormItem>
            <Icon type="ios-close" size="26" v-if="finalEditable && index > 0" @click="cut(index)" />
        </field-group>
        <div v-if="finalEditable" 
            style="line-height: 0;">
            <div class="parameter-add" @click="add">
                <Icon type="ios-add" class="parameter-add-plus" />添加参数
            </div>
        </div>
    </Form>
</template>
<script>
// 优惠费用
import { Field } from "ivux";

export default {
    name: "BrandParameters",

    mixins: [Field],

    props: {
        value: {
            type: Array,
            default: () => [],
        },
        populateType: {
            type: String,
            default: "chain",
        },
    },

    data() {
        return {
            list: [],
        };
    },

    watch: {
        value: {
            handler(val) {
                this.list = JSON.parse(JSON.stringify(val));
            },
            immediate: true,
        },
    },

    computed: {
        innerRules() {
            return {};
        },
    },
    methods: {
        add() {
            this.list.push({ title: "", price: "" });
        },

        cut(i) {
            this.list.splice(i, 1);
        },
    },
};
</script>
<style lang="less" scoped>
.parameter {
    &-item {
        margin-bottom: 12px;
        &-title {
            width: 60%;
        }
        &-price {
            width: 30%;
        }
    }

    &-cut {
        display: inline-block;
        cursor: pointer;
        line-height: 0;
        font-size: 18px;
        padding: 14px 10px;
        display: inline-block;
        border: 1px solid #ccc;
        border-radius: 4px;
        background: #fff;
    }

    &-add {
        display: inline-block;
        cursor: pointer;
        line-height: 14px;

        &-plus {
            line-height: 12px;
            padding: 0 2px;
            margin-right: 2px;
            border: 1px solid #ccc;
            margin-right: 5px;
            background: #fff;
        }
    }
}
</style>